<template>
  <div class="box fullscreen-element">
    <div class="boxIt"></div>
    <div class="topTap">
      <div class="tapItem" @click.stop="toWorship">纪念馆</div>
      <div class="tapItem showTap">陵园</div>
    </div>
    <div class="quitMan">
      <div class="qm-flex">
        <img
          @click="showSp = true"
          class="qm-img"
          :src="dieUser.picture ? dieUser.picture : dieUser.spiritTabletUrl"
          alt=""
          :style="{
            'object-fit': dieUser.picture ? 'cover' : 'contain',
          }"
        />
        <div>
          <div class="qm-name">
            {{
              dieUser.name?.length > 10
                ? dieUser.name.slice(0, 10) + "..."
                : dieUser.name
            }}纪念馆
          </div>
          <div class="qm-fire">
            <img
              v-if="dieUser.isHot == 1"
              class="fire-img"
              src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/fire.png"
              alt=""
            />
            <div class="fire-tit">香火值</div>
            <div class="fire-num">
              {{
                Number(fireNum) < 10000
                  ? unitConverterPlus(fireNum)
                  : moneyFormat(fireNum)
              }}
            </div>
          </div>
          <div class="qm-gl" @click="showewm = true">
            <img
              src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/ewm-icon-y.png"
              class="qm-icon"
              alt=""
            />
            <div class="qm-tit">邀请缅怀</div>
          </div>
        </div>
        <div class="qm-follow" @click="followHall" v-if="dieUser.type !== 2">
          {{ ifFollow ? "已关注" : "+关注" }}
        </div>
      </div>
    </div>
    <div
      class="picsorce"
      :style="{
        'padding-top': dieUser.picture ? $px2rem(`${20}px`) : 0,
      }"
    >
      <img
        class="manPic"
        v-if="dieUser.picture"
        :src="dieUser.picture"
        alt=""
      />
      <div
        class="manName"
        :style="{
          height: dieUser.picture ? $px2rem(`${123}px`) : $px2rem(`${221}px`),
          'margin-top': dieUser.picture ? $px2rem(`${13}px`) : 0,
          'justify-content': dieUser.picture ? 'flex-start' : 'center',
        }"
      >
        <div v-for="(item, index) in cosName(dieUser.name)" :key="index">
          {{ item }}
        </div>
        <div
          class="bdFlexleft"
          v-if="dieUser.birthDay"
          :style="{
            height: dieUser.picture ? $px2rem(`${123}px`) : $px2rem(`${221}px`),
            'margin-top': dieUser.picture ? $px2rem(`${13}px`) : 0,
            'justify-content': dieUser.picture ? 'flex-start' : 'center',
          }"
        >
          <div
            class="birTit"
            v-for="(item, index) in '生于' +
            (cosDate(dieUser.birthDay) || '???')"
            :key="index"
          >
            {{
              index >= 2 && Number(item) >= 0
                ? capitalizations[Number(item)]
                : item
            }}
          </div>
        </div>
        <div
          class="bdFlexright"
          v-if="dieUser.dieDay"
          :style="{
            height: dieUser.picture ? $px2rem(`${123}px`) : $px2rem(`${221}px`),
            'margin-top': dieUser.picture ? $px2rem(`${13}px`) : 0,
            'justify-content': dieUser.picture ? 'flex-start' : 'center',
          }"
        >
          <div
            class="birTit"
            v-for="(item, index) in '卒于' + (cosDate(dieUser.dieDay) || '???')"
            :key="index"
          >
            {{
              index >= 2 && Number(item) >= 0
                ? capitalizations[Number(item)]
                : item
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="rightBox">
      <div class="quitBox" @click.stop="goBack">
        <img class="leftIcon" src="@/assets/left-icon-f7.png" alt="" />
        退出
      </div>
      <div class="musicBox" @click="openMusicfuc">
        <img
          :class="{ musicIcon: true, rotImg: openMusic }"
          :src="openMusic ? zxUrl + '/openMusic.png' : zxUrl + '/offMusic.png'"
          alt=""
        />
        <audio :src="dieUser.musicUrl" ref="musicFile"></audio>
      </div>
      <div class="wornBox" @click="onReport">举报</div>
    </div>
    <div class="dropBox">
      <div class="giftRankTip">
        <div class="giftRank" v-if="giftRankList?.length > 0">
          <div
            class="rankItem"
            v-for="(item, index) in giftRankList.slice(0, 6)"
            :key="index"
            :style="{
              'margin-right':
                giftRankList?.length <= 6 && giftRankList?.length !== index + 1
                  ? $px2rem(`${20}px`)
                  : giftRankList?.length > 6 && 6 !== index + 1
                  ? $px2rem(`${20}px`)
                  : '0',
            }"
          >
            <div class="rankTitle" :class="{ rankBg: index > 2 }">
              <img
                class="rankNo"
                v-if="index == 0"
                src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/no1.png"
                alt=""
              />
              <img
                class="rankNo"
                v-if="index == 1"
                src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/no2.png"
                alt=""
              />
              <img
                class="rankNo"
                v-if="index == 2"
                src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/no3.png"
                alt=""
              />
              <img
                class="rankIcon"
                :class="{ borderClass: index > 2 }"
                :src="item.giftPicture"
                alt=""
              />
            </div>
            <div
              class="rankName"
              :style="{ color: index > 2 ? '#fff' : '#FFD74A' }"
            >
              {{
                item.sendSourceName?.length > 3
                  ? item.sendSourceName.slice(0, 3) + "..."
                  : item.sendSourceName
              }}
            </div>
            <div class="rankSend">
              送<span style="color: #ffe98d"
                >{{
                  item.giftName?.length > 5
                    ? item.giftName.slice(0, 5) + "..."
                    : item.giftName
                }}{{ item.giftCount || 0 }}个</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="deepBox" v-if="showDeep">
        <div
          :class="{ giftAll: true, giftOpen: !showOpenGift }"
          v-if="gotList && gotList.length > 0 && !showTap"
        >
          <div class="gftTop" v-if="showOpenGift">
            <div class="ga-box">
              <div class="ga-title">
                收到
                <span
                  style="color: #ffe98d; padding: 0 5px"
                  :style="{
                    'font-size': $px2rem(`${30}px`),
                    'padding-left': $px2rem(`${5}px`),
                    'padding-right': $px2rem(`${5}px`),
                  }"
                  >{{ totalGiftCount }}</span
                >件祭品
              </div>
              <div
                v-for="(item, index) in gotList.slice(0, 3)"
                :key="index"
                class="col4"
                :style="{
                  'margin-bottom':
                    showOpenGift == true ? '0' : $px2rem(`${10}px`),
                  'margin-left': $px2rem(`${10}px`),
                }"
              >
                <div class="ga-top">
                  <img :src="item.giftPicture" alt="" class="ga-img" />
                  <div
                    class="ga-exTime"
                    :style="{
                      color: item.expireTime ? '#FFE98D' : '#878787',
                    }"
                  >
                    {{ item.giftCount }}个
                    <!-- {{ item.expireTime ? getTime(item.expireTime) : "已过期" }} -->
                  </div>
                </div>
              </div>
            </div>
            <img
              v-if="showOpenGift && gotList && gotList.length > 0"
              src="@/assets/bot-icon.png"
              class="goBotIcon"
              alt=""
              @click.stop="showOpenGift = false"
            />
          </div>
          <div v-else>
            <div class="ga-title ga-left">
              收到
              <span
                style="color: #ffe98d; padding: 0 5px"
                :style="{
                  'font-size': $px2rem(`${30}px`),
                  'padding-left': $px2rem(`${5}px`),
                  'padding-right': $px2rem(`${5}px`),
                }"
                >{{ totalGiftCount }}</span
              >件祭品
            </div>
          </div>
          <div
            class="gftBot"
            :style="{
              'overflow-y': showOpenGift ? 'unset' : 'auto',
            }"
            id="scrollItem"
            v-if="!showOpenGift"
          >
            <div v-if="!showTap" class="gfAllBox">
              <div
                v-for="(item, index) in gotList"
                :key="index"
                class=""
                :style="{
                  'margin-bottom':
                    showOpenGift == true ? '0' : $px2rem(`${10}px`),
                  'margin-right': (index + 1) % 5 != 0 ? $px2rem(`${10}px`) : 0,
                }"
              >
                <div class="ga-top">
                  <img :src="item.giftPicture" alt="" class="ga-img" />
                  <div
                    class="ga-exTime"
                    :style="{
                      color: item.expireTime ? '#FFE98D' : '#878787',
                    }"
                  >
                    {{ item.giftCount }}个
                    <!-- {{ item.expireTime ? getTime(item.expireTime) : "已过期" }} -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="iconFlex" v-if="!showOpenGift">
            <img
              src="@/assets/bot-icon.png"
              class="goTopIcon"
              style="cursor: pointer"
              alt=""
              @click.stop="closeGift"
            />
            <span
              @click.stop="closeGift"
              style="color: #b6b6b6; cursor: pointer"
              :style="{
                'font-size': $px2rem(`${16}px`),
              }"
              >收起</span
            >
            <img
              @click.stop="changeTap"
              class="checkTap"
              src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/checkTap.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="deepLeep" v-else>
        <div
          :class="{ giftAll: true, giftOpen: !showOpenGift }"
          v-if="gotList && gotList.length > 0"
        >
          <div class="ga-title ga-left">
            收到
            <span
              style="color: #ffe98d; padding: 0 5px"
              :style="{
                'font-size': $px2rem(`${30}px`),
                'padding-left': $px2rem(`${5}px`),
                'padding-right': $px2rem(`${5}px`),
              }"
              >{{ totalGiftCount }}</span
            >件祭品
          </div>
          <div
            class="gftBot"
            :style="{
              'overflow-y': showOpenGift ? 'unset' : 'auto',
            }"
            style="padding: 0 10px"
            id="scrollItem"
            v-if="!showOpenGift"
          >
            <div v-if="!showTap" class="gfAllBox">
              <div
                v-for="(item, index) in gotList.slice(3, gotList.length)"
                :key="index"
                class=""
                :style="{
                  'margin-bottom':
                    showOpenGift == true ? '0' : $px2rem(`${10}px`),
                  'margin-right': (index + 1) % 5 != 0 ? $px2rem(`${10}px`) : 0,
                }"
              >
                <div class="ga-top">
                  <img :src="item.giftPicture" alt="" class="ga-img" />
                  <div
                    class="ga-exTime"
                    :style="{
                      color: item.expireTime ? '#FFE98D' : '#878787',
                    }"
                  >
                    {{ giftCount }}个
                    <!-- {{ item.expireTime ? getTime(item.expireTime) : "已过期" }} -->
                  </div>
                </div>
              </div>
            </div>
            <div class="gfChangeBox" v-else>
              <div
                v-for="(item, index) in tributeList"
                :key="index"
                class="giftAllBox"
              >
                <div style="display: flex">
                  <div
                    class="hideName"
                    style="color: #bf8e54"
                    :style="{
                      'font-size': $px2rem(`${16}px`),
                      'padding-right': $px2rem(`${8}px`),
                    }"
                  >
                    {{ item.sendSourceName }}
                  </div>
                  <span
                    style="color: #fff"
                    :style="{
                      'font-size': $px2rem(`${16}px`),
                    }"
                    >供奉了</span
                  >
                  <span
                    style="color: #feee5d"
                    :style="{
                      color: item.isPay == 1 ? '#FF6E6E' : '#feee5d',
                      'font-size': $px2rem(`${16}px`),
                    }"
                    >「{{ item.giftName }}」{{ item.giftCount }}个</span
                  >
                </div>
                <div
                  style="color: #b6b6b6"
                  :style="{
                    'font-size': $px2rem(`${14}px`),
                  }"
                >
                  {{ deepTime(item.createTime) }}
                </div>
              </div>
            </div>
          </div>
          <div class="iconFlex" v-if="!showOpenGift">
            <img
              src="@/assets/bot-icon.png"
              class="goTopIcon"
              alt=""
              style="opacity: 0"
            />
            <span
              style="color: #b6b6b6; opacity: 0"
              :style="{
                'font-size': $px2rem(`${16}px`),
              }"
              >收起</span
            >
            <img
              @click.stop="changeTap"
              class="checkTap"
              src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/checkTap.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <img
        class="checkTapPlus"
        src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/checkTap.png"
        alt=""
        @click.stop="changeTapPlus"
        v-if="showOpenGift && tributeList?.length > 0 && gotList?.length > 0"
      />
    </div>
    <div class="jidian" id="bottoms">
      <div
        class="jidianBox"
        :style="{
          'justify-content':
            giftMemoList.length > 5 ? 'space-between' : 'flex-start',
        }"
      >
        <div
          class="jdGift"
          v-for="(item, index) in giftMemoList.slice(0, 6)"
          :key="index"
          @click.stop="toBuyGift(item)"
          :style="{
            'margin-right': giftMemoList.length > 5 ? '0' : $px2rem(`${8}px`),
          }"
        >
          <img class="jdgiftImg" :src="item.giftPicture" alt="" />
          <div :style="{ 'font-size': $px2rem(`${11}px`) }">
            <span style="color: #fff; padding-right: 3px">{{
              item.giftName
            }}</span>
            <span style="color: #ffe192">{{
              item.giftValueOptions[0]?.price == "0"
                ? "免费"
                : "￥" + item.giftValueOptions[0]?.price
            }}</span>
          </div>
        </div>
      </div>
      <div
        class="jidianTit"
        @click.stop="
          !showGiftGif ? (showBuygift = true) : (showBuygift = false)
        "
      ></div>
    </div>
    <transition name="el-zoom-in-bottom" mode="out-in" appear>
      <div v-show="showBuygift" class="giftBuyBox">
        <!-- <div class="tabIts">
          <div class="tabIt" id="tabItWheel">
            <div
              v-for="(item, index) in tabBotList"
              :key="index"
              class="tabItem"
            >
              <div
                class="tabItemName"
                :class="{
                  tabCheck: tabCheckIndex == index,
                }"
                :style="{
                  'margin-right': index + 1 !== 5 ? $px2rem(`${10}px`) : '0',
                }"
                @click.stop="checkTab(item, index)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div> -->
        <img
          src="@/assets/gift-close.png"
          class="closeIcon"
          @click.stop="toCloseBuy"
          alt=""
        />
        <div class="scrollBoxs">
          <div class="scrollBox">
            <div class="grods">
              <div
                v-for="(item, index) in gordList"
                :key="index"
                :class="{ 'grid-content': true }"
                @click="toBuyGift(item)"
              >
                <img class="gdgiftImg" :src="item.giftPicture" alt="" />
                <div :style="{ 'font-size': $px2rem(`${11}px`) }">
                  <span style="color: #fff; padding-right: 3px">{{
                    item.giftName
                  }}</span>
                  <span style="color: #ffe192">{{
                    item.giftValueOptions[0]?.price == "0"
                      ? "免费"
                      : "￥" + item.giftValueOptions[0]?.price
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-zoom-in-center">
      <div v-show="showSp" class="sp-box">
        <div style="position: relative">
          <div class="sp-title">生平</div>
          <img
            @click.stop="showSp = false"
            src="@/assets/sp-close.png"
            class="sp-close"
            alt=""
          />
        </div>
        <div class="tabSimple">
          <div class="tabTop">
            <div
              class="tabTop-item"
              v-for="(item, index) in tabList"
              :key="index"
              @click.stop="getVideo(item, index)"
            >
              <div
                :class="{ 'tap-name': true, 'tap-check': tabIndex == index }"
              >
                {{ item.name }}
              </div>
              <transition name="el-fade-in-linear">
                <div class="line-Bot" v-show="tabIndex == index"></div>
              </transition>
            </div>
          </div>
          <div class="tabBottom">
            <div
              class="tabBottom-item"
              :style="{
                'padding-left':
                  tab2Index == 0 || tab2Index == 1
                    ? $px2rem(`${10}px`)
                    : $px2rem(`${30}px`),
                'padding-right':
                  tab2Index == 0 || tab2Index == 1
                    ? $px2rem(`${10}px`)
                    : $px2rem(`${30}px`),
              }"
              v-for="(item, index) in tabList"
              :key="index"
            >
              <div v-show="tabIndex == index">
                <div v-show="tabIndex == 0">
                  <div class="sp-item">
                    <div>逝者照片:</div>
                    <img
                      class="diePhoto"
                      :src="
                        dieUser.picture
                          ? dieUser.picture
                          : dieUser.spiritTabletUrl
                      "
                      :style="{
                        'object-fit': dieUser.picture ? 'cover' : 'contain',
                      }"
                      alt=""
                    />
                  </div>
                  <div class="sp-item">
                    <div>逝者姓名:</div>
                    <div class="sp-geo">{{ dieUser.name }}</div>
                  </div>
                  <div class="sp-item">
                    <div>逝者性别:</div>
                    <div class="sp-geo">
                      {{ dieUser.sex == 2 ? "女" : "男" }}
                    </div>
                  </div>
                  <div class="sp-item">
                    <div>出生日期:</div>
                    <div class="sp-geo">{{ dieUser.birthDay || "不详" }}</div>
                  </div>
                  <div class="sp-item">
                    <div>逝世日期:</div>
                    <div class="sp-geo">{{ dieUser.dieDay || "不详" }}</div>
                  </div>
                  <div class="sp-item">
                    <div>安葬地址:</div>
                    <div class="sp-geo">
                      {{
                        dieUser &&
                        dieUser.burialArea &&
                        dieUser.burialArea.fullName
                          ? dieUser.burialArea.fullName
                          : "不详"
                      }}
                    </div>
                  </div>
                </div>
                <div v-show="tabIndex == 1">
                  <div class="sp-area" v-html="dieUser.remark"></div>
                  <!-- <textarea class="sp-area" v-model="dieUser.remark" disabled>
                  </textarea> -->
                </div>
                <div v-show="tabIndex == 2">
                  <div>
                    <div class="videoBox">
                      <div
                        class="video-item"
                        v-for="(item, index) in videoList"
                        :key="index"
                        @click="toPlayVideo(item)"
                        :style="{
                          'margin-right':
                            (index + 1) % 4 == 0 ? '0' : $px2rem(`${16}px`),
                        }"
                      >
                        <img :src="item.ext1" class="video-src" alt="" />
                        <img
                          class="play-icon"
                          src="@/assets/video-play.png"
                          alt=""
                        />
                        <div class="zhezhao-small"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="tabIndex == 3">
                  <div>
                    <div class="videoBox">
                      <div
                        class="video-item"
                        v-for="(item, index) in imgList"
                        :key="index"
                        :style="{
                          'margin-right':
                            (index + 1) % 4 == 0 ? '0' : $px2rem(`${16}px`),
                        }"
                      >
                        <img :src="item.attaSource" class="video-src" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="sp-but">
                  <div class="sp-cancle" @click="showSp = false">取消</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-zoom-in-center">
      <div v-show="showgl" class="sp-l-box">
        <div style="position: relative">
          <div class="sp-title">祠堂布置</div>
          <img
            @click.stop="showgl = false"
            src="@/assets/sp-close.png"
            class="sp-close"
            alt=""
          />
        </div>
        <div class="tabSimple">
          <div class="tabTop">
            <div
              class="tabTop-item"
              v-for="(item, index) in tab2List"
              :key="index"
              @click="tab2Index = index"
            >
              <div
                :class="{ 'tap-name': true, 'tap-check': tab2Index == index }"
              >
                {{ item.name }}
              </div>
              <transition name="el-fade-in-linear">
                <div class="line-Bot" v-show="tab2Index == index"></div>
              </transition>
            </div>
          </div>
          <div class="tabBottom">
            <div
              class="tabBottom-item"
              :style="{
                'padding-left':
                  tab2Index == 0 || tab2Index == 1 || tab2Index == 2
                    ? $px2rem(`${10}px`)
                    : $px2rem(`${30}px`),
                'padding-right':
                  tab2Index == 0 || tab2Index == 1 || tab2Index == 2
                    ? $px2rem(`${10}px`)
                    : $px2rem(`${30}px`),
              }"
              v-for="(item, index) in tab2List"
              :key="index"
            >
              <div v-show="tab2Index == index">
                <div
                  v-show="tab2Index == 0"
                  style="overflow: hidden; overflow-y: auto"
                  :style="{
                    height: $px2rem(`${400}px`),
                  }"
                >
                  <div class="st-box">
                    <div
                      class="st-item"
                      v-for="(item, index) in styleList"
                      :key="index"
                      :style="{
                        background: item.isUsing ? '#F0B75D' : 'transparent',
                        'margin-right':
                          (index + 1) % 3 == 0 ? '0' : $px2rem(`${10}px`),
                      }"
                    >
                      <div class="st-items">
                        <div
                          class="st-back"
                          @mouseover="showPreview(item, index)"
                          @mouseleave="hidePreview"
                        >
                          <div
                            v-if="showPreviews[index]"
                            class="preview"
                            @click="onPreview(item)"
                          >
                            预览
                          </div>
                          <img :src="item.url" class="st-item-bg" alt="" />
                          <img
                            v-if="item.isHave"
                            src="@/assets/status-icon.png"
                            style="position: absolute; top: 0; right: 0"
                          />
                          <!--                          <img-->
                          <!--                            class="timo-icon"-->
                          <!--                            src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo/activeInTiome-icon.png"-->
                          <!--                            alt=""-->
                          <!--                            v-if="item.price !== '0'"-->
                          <!--                          />-->
                        </div>
                        <div
                          :style="{
                            'padding-left': $px2rem(`${20}px`),
                            'padding-right': $px2rem(`${20}px`),
                          }"
                        >
                          <div class="st-item-title">{{ item.name }}</div>
                          <!--                          <div class="st-item-price">-->
                          <!--                            {{ item.price == 0 ? "免费" : "￥" + item.price }}-->
                          <!--                            <span-->
                          <!--                              v-if="item.price != '0'"-->
                          <!--                              style="color: #575757; font-weight: 400"-->
                          <!--                              :style="{-->
                          <!--                                'font-size': $px2rem(`${14}px`),-->
                          <!--                              }"-->
                          <!--                              >/终身</span-->
                          <!--                            >-->
                          <!--                          </div>-->
                          <div class="st-item-price" v-if="item.isHave">
                            <span
                              style="color: #575757; font-weight: 400"
                              :style="{
                                'font-size': $px2rem(`${14}px`),
                              }"
                              >终身有效</span
                            >
                          </div>
                          <div
                            class="st-item-price"
                            v-else-if="item.price == 0"
                          >
                            免费
                          </div>
                          <div class="st-item-price" v-else>
                            {{ "￥" + item.price }}
                            <span
                              style="color: #575757; font-weight: 400"
                              :style="{
                                'font-size': $px2rem(`${14}px`),
                              }"
                              >/终身</span
                            >
                          </div>
                          <div
                            :class="[item.isUsing ? 'inUse' : 'useNow']"
                            @click.stop="checkUsed(item)"
                          >
                            {{ item.isUsing ? "在使用" : "立即使用" }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-show="tab2Index === 1"
                  :style="{
                    height: $px2rem(`${400}px`),
                  }"
                >
                  <div class="tabletBox">
                    <div @click="boxColorCheck(1)" style="width: 33%">
                      <div class="tabletBoxColorBox">
                        <img
                          class="tabletImg"
                          src="https://oss.lgyin.com/file/6a927610-2274-4791-838e-53a02d4b8e2a.581d0f18-d02a-408c-853d-0033b90e9dd5"
                        />
                      </div>
                      <div>
                        <img
                          src="@/assets/radio_true.png"
                          :style="{
                            width: $px2rem(`${30}px`),
                            height: $px2rem(`${30}px`),
                          }"
                          v-if="checkBoxColor === 1"
                        />
                        <img
                          src="@/assets/radio_false.png"
                          :style="{
                            width: $px2rem(`${30}px`),
                            height: $px2rem(`${30}px`),
                          }"
                          v-else
                        />
                      </div>
                    </div>
                    <div @click="boxColorCheck(2)" style="width: 33%">
                      <div class="tabletBoxColorBox">
                        <div style="position: relative">
                          <img
                            class="tabletImg"
                            src="https://oss.lgyin.com/file/6a927610-2274-4791-838e-53a02d4b8e2a.581d0f18-d02a-408c-853d-0033b90e9dd5"
                          />
                          <div class="tabletButtBox">1889-1920</div>
                        </div>
                      </div>
                      <div>
                        <img
                          src="@/assets/radio_true.png"
                          :style="{
                            width: $px2rem(`${30}px`),
                            height: $px2rem(`${30}px`),
                          }"
                          v-if="checkBoxColor === 2"
                        />
                        <img
                          src="@/assets/radio_false.png"
                          :style="{
                            width: $px2rem(`${30}px`),
                            height: $px2rem(`${30}px`),
                          }"
                          v-else
                        />
                      </div>
                    </div>
                    <div @click="boxColorCheck(3)" style="width: 33%">
                      <div class="tabletBoxColorBox" style="position: relative">
                        <img
                          class="tabletImg"
                          src="https://oss.lgyin.com/file/6a927610-2274-4791-838e-53a02d4b8e2a.581d0f18-d02a-408c-853d-0033b90e9dd5"
                        />
                        <div class="tabletBoxVTextLeft">生 于 一 八 八 八</div>
                        <div class="tabletBoxVTextRight">卒 于 一 九 四 九</div>
                      </div>
                      <div>
                        <img
                          src="@/assets/radio_true.png"
                          :style="{
                            width: $px2rem(`${30}px`),
                            height: $px2rem(`${30}px`),
                          }"
                          v-if="checkBoxColor === 3"
                        />
                        <img
                          src="@/assets/radio_false.png"
                          :style="{
                            width: $px2rem(`${30}px`),
                            height: $px2rem(`${30}px`),
                          }"
                          v-else
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="tab2Index == 2">
                  <div class="sp-gl-area">
                    <el-input
                      type="textarea"
                      maxlength="30000"
                      resize="none"
                      :rows="12"
                      placeholder="请输入内容"
                      v-model="lifeHis"
                      class="areaHis"
                      :disabled="dieUser.canDelete == 0"
                    >
                    </el-input>
                  </div>
                </div>
                <div class="sp-but">
                  <div class="sp-cancle" @click="showgl = false">取消</div>
                  <div
                    class="sp-submit"
                    @click="editLifeHis(item)"
                    v-if="
                      (tab2Index == 2 || tab2Index == 1) &&
                      dieUser.canDelete == 1
                    "
                  >
                    确定
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-zoom-in-center">
      <div v-show="showewm" class="sp-s-box">
        <div class="sp-s-main">
          <div style="position: relative" class="sp-s-top">
            <div>
              <img
                @click.stop="showewm = false"
                src="@/assets/sp-close.png"
                class="sp-close"
                alt=""
              />
            </div>
            <div class="sp-s-mid">
              <img
                class="sp-s-icon"
                :src="
                  dieUser.picture ? dieUser.picture : dieUser.spiritTabletUrl
                "
                alt=""
                :style="{
                  'object-fit': dieUser.picture ? 'cover' : 'contain',
                }"
              />
            </div>
            <div class="sp-title">{{ dieUser.name }}纪念馆</div>
            <div class="sp-title-p">网上纪念馆 让思念永远在线</div>
          </div>
          <div>
            <div class="qrcodeBox">
              <vue-qr
                :style="{
                  width: $px2rem(`${160}px`),
                  height: $px2rem(`${166}px`),
                }"
                :text="
                  'https://zaixianjisi.com/subapp/sub-h5/pavilion?id=' +
                  userId +
                  '&source=codes&secondType=2'
                "
              ></vue-qr>
            </div>
            <div class="qrcodeTit">微信扫一扫,打开手机端</div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="el-zoom-in-center">
      <div
        v-show="showPayDia"
        style="
          width: 487px;
          padding-bottom: 50px;
          box-sizing: border-box;
          z-index: 201;
          top: 20%;
          position: absolute;
          left: 0;
          right: 0;
          margin: 0 auto;
          border-radius: 14px;
          background: linear-gradient(180deg, #ffffff 42%, #fff4ef 100%);
        "
      >
        <div
          style="
            width: 487px;
            height: 49px;
            background: #583725;
            border-radius: 14px 14px 0 0;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <div
            style="
              font-size: 20px;
              color: #ffffff;
              font-weight: 600;
              line-height: 28px;
              letter-spacing: 0.04em;
              text-align: center;
            "
          >
            订单支付
          </div>
          <div
            style="position: absolute; top: 10px; right: 20px"
            @click="closeOrder"
          >
            <img
              src="@/assets/pay_close.png"
              style="width: 13px; height: 13px"
            />
          </div>
        </div>

        <div v-show="orderCreate.step === 1">
          <div
            style="
              color: #ff523a;
              line-height: 1;
              margin-top: 45px;
              margin-bottom: 44px;
            "
          >
            <span style="font-size: 32px">￥</span>
            <span style="font-size: 50px; font-weight: 600">{{ howMuch }}</span>
          </div>
          <div v-for="(item, index) in zhifuList" :key="index">
            <div
              style="
                width: 407px;
                height: 80px;
                border-radius: 10px;
                border: 2px solid #ffcb7ead;
                margin: 0 auto;
                background: #fff6e9;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 17px;
                padding: 0 25px;
                box-sizing: border-box;
              "
              @click="changeZhifuTap(item)"
            >
              <div style="display: flex">
                <img :src="item.url" style="width: 40px; height: 40px" />
                <div style="margin-left: 5px">
                  <div
                    style="
                      font-size: 16px;
                      font-weight: 400;
                      line-height: 22.4px;
                      text-align: left;
                      color: #575757;
                    "
                  >
                    {{ item.name }}支付
                  </div>
                  <div
                    style="
                      font-size: 12px;
                      font-weight: 400;
                      line-height: 16.8px;
                      text-align: left;
                      color: #8a8a8a;
                    "
                  >
                    使用{{ item.name }}扫码支付
                  </div>
                </div>
              </div>
              <div>
                <img
                  src="@/assets/radio_true.png"
                  style="width: 30px; height: 30px"
                  v-if="item.check"
                />
                <img
                  src="@/assets/radio_false.png"
                  style="width: 30px; height: 30px"
                  v-else
                />
              </div>
            </div>
          </div>
          <!-- <div
            style="
              width: 345px;
              height: 100px;
              border-radius: 10px;
              border: 2px solid #ffcb7ead;
              margin: 50px auto 0 auto;
              background: #fff6e9;
              display: flex;
              align-items: center;
              justify-content: space-around;
            "
            @click="orderCreate.paymentType = 3"
          >
            <div style="display: flex">
              <img
                src="@/assets/wechat.png"
                style="width: 40px; height: 40px"
              />
              <div style="margin-left: 5px">
                <div
                  style="
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 22.4px;
                    text-align: left;
                    color: #575757;
                  "
                >
                  微信支付
                </div>
                <div
                  style="
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16.8px;
                    text-align: left;
                    color: #8a8a8a;
                  "
                >
                  使用微信扫码支付
                </div>
              </div>
            </div>
            <div>
              <img
                src="@/assets/radio_true.png"
                style="width: 30px; height: 30px"
                v-if="orderCreate.paymentType === 3"
              />
              <img
                src="@/assets/radio_false.png"
                style="width: 30px; height: 30px"
                v-else
              />
            </div>
          </div> -->
          <!-- <div  style="
              width: 345px;
              height: 70px;
              border-radius: 10px;
              display: flex;
              align-items: center;
              justify-content: space-around;"></div> -->

          <!-- <div
            style="
              width: 345px;
              height: 100px;
              border-radius: 10px;
              border: 2px solid #ffcb7ead;
              margin: 0 auto;
              margin-top: 10px;
              background: #fff6e9;
              display: flex;
              align-items: center;
              justify-content: space-around;
            "
            @click="orderCreate.paymentType = 1"
          >
            <div style="display: flex">
              <img src="@/assets/ali.png" style="width: 40px; height: 40px" />
              <div style="margin-left: 5px">
                <div
                  style="
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 22.4px;
                    text-align: left;
                    color: #575757;
                  "
                >
                  支付宝支付
                </div>
                <div
                  style="
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16.8px;
                    text-align: left;
                    color: #8a8a8a;
                  "
                >
                  使用支付宝扫码支付
                </div>
              </div>
            </div>
            <div>
              <img
                src="@/assets/radio_true.png"
                style="width: 30px; height: 30px"
                v-if="orderCreate.paymentType === 1"
              />
              <img
                src="@/assets/radio_false.png"
                style="width: 30px; height: 30px"
                v-else
              />
            </div>
          </div> -->
          <div
            style="
              width: 190px;
              height: 48px;
              background-color: #4a2a19;
              border-radius: 8px;
              margin: 0 auto;
              align-items: center;
              display: flex;
              justify-content: center;
            "
            @click="orderPre"
          >
            <div
              style="
                font-size: 16px;
                font-weight: 400;
                line-height: 22.4px;
                color: #ffffff;
                text-align: center;
              "
            >
              确定
            </div>
          </div>
        </div>

        <div v-show="orderCreate.step === 2">
          <div
            style="margin-top: 20px; display: flex; justify-content: left"
            @click="orderPreStep"
          >
            <img
              src="@/assets/left-icon.png"
              style="width: 12px; height: 21px; margin-left: 22px"
            />
            <div
              style="
                font-size: 20px;
                font-weight: 400;
                line-height: 26px;
                text-align: center;
                color: #b6b6b6;
                margin-left: 14px;
              "
            >
              返回
            </div>
          </div>
          <div
            style="
              margin-top: 15px;
              align-items: center;
              display: flex;
              justify-content: center;
            "
          >
            <div style="display: flex" v-if="orderCreate.paymentType === 3">
              <img
                src="@/assets/wechat.png"
                style="width: 40px; height: 40px"
              />
              <div style="margin-left: 5px">
                <div
                  style="
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 22.4px;
                    text-align: left;
                    color: #575757;
                  "
                >
                  微信支付
                </div>
                <div
                  style="
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16.8px;
                    text-align: left;
                    color: #8a8a8a;
                  "
                >
                  使用微信扫码支付
                </div>
              </div>
            </div>
            <div style="display: flex" v-if="orderCreate.paymentType === 1">
              <img src="@/assets/ali.png" style="width: 40px; height: 40px" />
              <div style="margin-left: 5px">
                <div
                  style="
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 22.4px;
                    text-align: left;
                    color: #575757;
                  "
                >
                  支付宝支付
                </div>
                <div
                  style="
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16.8px;
                    text-align: left;
                    color: #8a8a8a;
                  "
                >
                  使用支付宝扫码支付
                </div>
              </div>
            </div>
          </div>
          <div
            style="
              width: 198px;
              height: 210px;
              border: 1px solid #e9e9e9;
              margin: 0 auto;
              margin-top: 22px;
            "
          >
            <div v-if="orderCreate.paymentType === 3" style="margin-top: 10px">
              <vue-qr
                style="width: 142px; height: 147px"
                :text="orderCreate.outBody"
              ></vue-qr>
            </div>
            <div
              v-if="orderCreate.paymentType === 1"
              style="
                width: 142px;
                height: 142px;
                margin: 0 auto;
                margin-top: 10px;
              "
            >
              <iframe
                :srcdoc="orderCreate.outBody"
                frameborder="no"
                border="0"
                marginwidth="0"
                marginheight="0"
                scrolling="no"
                width="142"
                height="142"
                style="overflow: hidden"
              >
              </iframe>
            </div>
            <div
              style="
                font-size: 12px;
                font-weight: 400;
                line-height: 16.8px;
                color: #575757;
                word-wrap: break-word;
                width: 106px;
                margin: 0 auto;
                margin-top: 10px;
                text-align: center;
              "
            >
              <div>
                打开手机端{{
                  orderCreate.paymentType === 1 ? "支付宝" : "微信"
                }}
              </div>
              <div>扫一扫继续付款</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div
      class="zhezhao"
      v-show="showSp || showgl || showewm || showZxewm || showGwc"
      @click="
        showSp = false;
        showgl = false;
        showewm = false;
        showZxewm = false;
        showGwc = false;
        dropIt = 0;
        gwcData = [];
      "
    ></div>
    <div class="zhezhao2" v-show="showPayDia" @click="showPayDia = false"></div>
    <!-- <div id="container"></div> -->
    <el-dialog
      :visible.sync="showVideo"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :modal="false"
      width="40%"
      center
      top="20vh"
      v-if="showVideo"
    >
      <div>
        <video
          v-if="videoSrc"
          class="videoItem"
          ref="videoDom"
          :src="videoSrc"
          :autoPlay="autoPlay"
          controls
        ></video>
      </div>
    </el-dialog>
    <!-- giftgif -->
    <div v-if="showGiftGif" class="gifBox">
      <!-- <img
        class="bookgif"
        src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/book.gif"
        alt=""
      /> -->
      <div
        class="bookIt"
        :style="{ background: 'url(' + backgroundImageUrl + ') no-repeat' }"
      >
        <div class="bookTxt" v-if="showBooktxt" id="text-container">
          时值{{ bookTime }}为逝者{{ dieUser.name }}奉上祭品{{
            bookGift
          }},愿逝者在天有灵得以幸福安康，谨此以黄表为证。
        </div>
        <img
          @click="
            showGiftGif = false;
            showBooktxt = false;
          "
          class="gifClose"
          src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/gifClose.png"
          alt=""
        />
      </div>
      <img
        class="luzi"
        src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/luzi.gif"
        alt=""
      />
      <img
        @click="
          showGiftGif = false;
          showBooktxt = false;
        "
        class="gifSure"
        src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/gifSure.png"
        alt=""
      />
      <transition name="el-fade-in-linear" v-if="showBurnimg">
        <div class="gifBoxcome" v-if="giftUrl">
          <img :src="giftUrl" class="gifImg" alt="" />
        </div>
      </transition>
    </div>
    <div class="zhezhao2" v-if="showPayDia"></div>
    <transition name="el-zoom-in-center">
      <div v-show="showZxewm" class="sp-s-boxs">
        <img
          @click.stop="showZxewm = false"
          src="@/assets/sp-close.png"
          class="sp-closes"
          alt=""
        />
        <div>
          <div class="qrTitle">进入知孝 查看更多资料</div>
          <div class="qrcodeBox">
            <img
              class="ewmIcon"
              src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/zxUrlIcon.png"
              alt=""
              srcset=""
            />
          </div>
          <div class="qrcodeTit">手机扫一扫 认识更多朋友</div>
        </div>
        <div class="sp-but">
          <div class="sp-cancle" @click="showZxewm = false">取消</div>
        </div>
      </div>
    </transition>
    <transition name="el-zoom-in-center">
      <div v-if="showBuyBox" class="toBuyBox">
        <img
          @click.stop="
            showBuyBox = false;
            buyIndex = 0;
          "
          src="@/assets/sp-close.png"
          class="by-close"
          alt=""
        />
        <img :src="buyGift.giftPicture" alt="" class="by-img" />
        <div class="by-name">{{ buyGift.giftName }}</div>
        <div class="by-days">
          <div
            class="by-dayAll"
            :style="{
              'justify-content':
                buyGift.giftValueOptions.length % 4 == 0
                  ? 'space-between'
                  : 'center',
            }"
          >
            <div
              class="by-day"
              :style="{
                'margin-right': (index + 1) % 3 == 0 ? '0' : $px2rem(`${12}px`),
                background: buyIndex == index ? '#B08C51' : '#B08C514D',
              }"
              v-for="(item, index) in buyGift.giftValueOptions"
              :key="index"
              @click.stop="buyIndex = index"
            >
              {{ item.time }}天
            </div>
          </div>
          <div class="by-flex">
            <div
              class="by-price"
              :style="{
                'margin-right': $px2rem(`${30}px`),
              }"
            >
              价格:
              <span
                style="color: #f13535"
                v-if="buyGift.giftValueOptions[buyIndex].price !== 0"
                :style="{
                  'font-size': $px2rem(`${18}px`),
                }"
                >￥</span
              >
              <span
                style="color: #f13535"
                :style="{
                  'font-size':
                    buyGift.giftValueOptions[buyIndex].price == 0
                      ? $px2rem(`${18}px`)
                      : $px2rem(`${28}px`),
                }"
                >{{
                  buyGift.giftValueOptions[buyIndex].price == 0
                    ? "免费"
                    : buyGift.giftValueOptions[buyIndex].price
                }}</span
              >
            </div>
            <div class="by-price">
              香火值:<span
                style="color: #ffe192"
                :style="{
                  'font-size': $px2rem(`${18}px`),
                }"
                >+{{ buyGift.giftValueOptions[buyIndex].value }}</span
              >
            </div>
          </div>
          <div class="ocFlex">
            <img
              class="toBuyOc"
              @click.stop="toCart"
              src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/gwc-add.png"
              style="margin-right: 10px"
              alt=""
            />
            <img
              class="toBuyOc"
              @click.stop="toBuy"
              src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/buy-add.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </transition>

    <!-- 举报弹窗 -->
    <div id="popup" class="popup" v-show="showReport">
      <div class="popup-content">
        <!-- <span class="close" id="closePopup">&times;</span> -->
        <div class="top-nav">
          <span class="top-title">举报</span>
          <span @click="handleClose" class="close" id="closePopup"
            >&times;</span
          >
          <div class="reason">
            <div class="symbol">*</div>
            <span class="reason-span">举报理由</span>
          </div>
          <div class="reason-ct">
            <div
              class="list"
              v-for="(item, index) in reasonList"
              :key="index"
              v-bind:value="selectedValues"
              @click="changeType(item)"
            >
              <img
                v-if="item.dictValue != reportType.dictValue"
                src="@/assets/new/radios.png"
                alt=""
                srcset=""
              />
              <img
                v-if="item.dictValue == reportType.dictValue"
                src="@/assets/new/radio.png"
                alt=""
                srcset=""
              />
              <span style="line-height: 28px">{{ item.dictLabel }}</span>
            </div>
          </div>
        </div>

        <div class="reason" style="padding-top: 40px">
          <div class="symbol">*</div>
          <span class="reason-span">举报描述</span>
        </div>

        <div class="reason-div">
          <textarea
            class="reason-textarea"
            placeholder="举报描述..."
            v-model="report.describe"
          ></textarea>
        </div>

        <div class="reason" style="padding-top: 40px">
          <span class="reason-span">图片材料提交</span>
        </div>

        <div style="margin: 20px">
          <el-upload
            ref="upload"
            class="avatar-uploader"
            :action="action"
            :headers="header"
            :show-file-list="true"
            :limit="3"
            :on-change="handleUploadChange"
            :fileList="fileList"
            list-type="picture-card"
            :on-success="handleAvatarSuccess"
            :on-remove="onRemove"
            accept=".png,.jpg,.jpeg"
            @mouseenter.native="mouseCover"
            @mouseleave.native="mouseOut"
            :before-upload="beforeUpload"
            :disabled="isUploadDisabled"
          >
            <div class="plus">
              <img
                style="width: 39px; height: 39px; margin-top: 30px"
                src="@/assets/new/jia.png"
                alt=""
              />
              <!-- <span v-if="isPhoto" class="plus-text">禁止点击</span> -->
              <span class="plus-text">请上传照片</span>
            </div>
            <!-- <div class="mouse-info" v-show="showInfo">
              <img src="@/assets/upload-icon.png" />
              <div class="text">修改照片</div>
            </div> -->
          </el-upload>
        </div>

        <div
          :class="{ saveBut: true, 'active-btn': isComputed }"
          @click="saveForm"
        >
          提交举报
        </div>
      </div>
    </div>
    <div class="bgImg" v-show="enlarge">
      <div class="preview-div">
        <div class="close-preview" @click="enlarge = false">X</div>
        <img :src="previewImg" alt="" />
      </div>
    </div>
    <!-- 购物车 -->
    <div class="gwcBox" @click.stop="openGwc">
      <img
        class="gwcIcon"
        src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/gwcIcon.png"
        alt=""
      />
      <div class="redBadge">{{ gwcList.length }}</div>
    </div>
    <transition name="el-zoom-in-center">
      <div v-show="showGwc" class="toGwcBox">
        <img
          @click.stop="
            showGwc = false;
            dropIt = 0;
            gwcData = [];
          "
          src="@/assets/sp-close.png"
          class="by-close"
          alt=""
        />
        <div class="dropTop">
          <div
            class="dropTit dropR"
            :class="{
              dropPos: dropIt == 0,
            }"
            @click.stop="dropIt = 0"
          >
            购物车({{ gwcList.length }})
          </div>
          <div
            class="dropTit"
            :class="{
              dropPos: dropIt == 1,
            }"
            @click.stop="dropIt = 1"
          >
            已送出的供品
          </div>
        </div>
        <div class="checkBot" v-if="dropIt == 0">
          <div class="checkAll">
            <img
              class="checkAllImg"
              src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/gwc-check.png"
              alt=""
              v-if="!gwcCheck"
              @click.stop="toCheckAllGwc(0)"
            />
            <img
              class="checkAllImg"
              src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/gwc-checked.png"
              alt=""
              v-else
              @click.stop="toCheckAllGwc(1)"
            />
            全选
          </div>
          <div class="delAll" @click="delGwc">删除</div>
        </div>
        <div class="gwcList" v-if="dropIt == 0">
          <div
            class="gwcListItem"
            v-for="(item, index) in gwcList"
            :key="index"
            @click.stop="tocheckGwc(item)"
            :style="{
              border: item.check ? '1px solid #D5422C' : 'none',
              background: item.check ? '#D5422C1A' : '#5E4635',
            }"
          >
            <div v-if="item.disabled == 2">
              <img
                class="checkImg"
                src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/gwc-check.png"
                alt=""
                v-if="!item.check"
              />
              <img
                class="checkImg"
                src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/gwc-checked.png"
                alt=""
                v-else
              />
            </div>
            <div class="checkDisabled" v-else></div>
            <div class="gwcImgBg">
              <img class="gwcImgDos" :src="item.giftPicture" alt="" />
              <div class="downShop" v-if="item.disabled == 1">商品已下架</div>
            </div>
            <div class="gwc-name">{{ item.giftName }}</div>
            <div class="gwc-day">{{ item?.currentOption?.time || 0 }}天</div>
            <div class="fireBoxnu">
              <img
                class="fireIconimg"
                src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/gwcfireIcon.png"
                alt=""
              />
              <span class="fireTxt">香火值:</span>
              <span class="fireNum"
                >+{{ item?.currentOption?.value || 0 }}</span
              >
            </div>
            <div
              class="firePri"
              v-if="item.currentOption?.price >= 0"
              :class="[item?.currentOption?.price == 0 ? 'frtxt' : 'extxt']"
            >
              {{
                item?.currentOption?.price == 0
                  ? "免费"
                  : "￥" + item?.currentOption?.price
              }}
            </div>
            <div class="firePri" v-else>已失效</div>
            <div class="posgwcDel" @click.stop="delGwcsingle(item)">删除</div>
          </div>
        </div>
        <div class="gwcCheckOut" v-if="dropIt == 0">
          <div class="pickedtxt">
            已选
            <span class="sumAllt">{{ gwcData.length || 0 }}</span>
            件供品
          </div>
          <div class="pickedNum">
            合计:
            <span class="sumAllp">￥{{ gwcPlusPrice() }}</span>
          </div>
          <div class="checkoutBtn" @click="toCheckOut">结算</div>
        </div>
        <div v-if="dropIt == 1" :style="{ 'margin-top': $px2rem(`${25}px`) }">
          <div
            class="gwcList"
            @scroll="loadScroll($event)"
            :style="{ height: $px2rem(`${520}px`) }"
          >
            <div
              class="gwcListItem"
              v-for="(item, index) in myCart"
              :key="index"
              style="justify-content: space-between"
            >
              <div class="gwcImgBg">
                <img class="gwcImgDos" :src="item?.giftPicture" alt="" />
              </div>
              <div class="gwc-name">{{ item?.giftName }}</div>
              <div class="gwc-day">{{ item?.dayCount }}天</div>
              <div class="fireBoxnu marginr">
                <img
                  class="fireIconimg"
                  src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/gwcfireIcon.png"
                  alt=""
                />
                <span class="fireTxt">香火值:</span>
                <span class="fireNum">+{{ item?.giftSumScore || 0 }}</span>
              </div>
              <div
                class="gwc-price"
                :class="[item?.price == 0 ? 'frtxt' : 'extxt']"
              >
                {{ item?.price == 0 ? "免费" : "￥" + item.price }}
              </div>
              <div class="gwc-gname">
                {{ item?.secondType == 1 ? "纪念馆" : "陵园" }}
              </div>
              <div class="gwc-gtime">{{ item?.createTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import {
  getGiftsOnline,
  getHallatta,
  getHalldetail,
  getVideoById,
  getGiftsHall,
  orderPre,
  orderQueryStatus,
  sendGift,
  getDanmu,
  toLeaveMessage,
  actionAll,
  editHall,
  getGiftDie,
  getGiftList,
  getGiftType,
  tabletStyleSet,
  getGiftrank,
  getDictTypeDate,
  toaddCartList,
  getCartList,
  getCartCount,
  delCartItem,
  getCartListforme,
  toCartGiftforFree,
  getSpecialCount,
} from "@/api/request";

import { styleList, styleSet, reportfList, reportSubmit } from "@/api/request";
import { Base64 } from "js-base64";
import { getToken } from "@/utils/auth";
import { debounce, throttle } from "@/utils/dbucTrtl.js";
export default {
  components: { vueQr },
  data() {
    return {
      isPhoto: false,
      isUploadDisabled: false,
      isActive: false,
      tabletStyleId: 1,
      orderCreate: {
        step: 1,
        paymentType: 3,
        tradeNo: null,
        outBody: "",
      },
      showPayDia: false,
      zxUrl:
        "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3",
      screenWidth: 0,
      screenHeight: 0,
      showSp: false,
      showgl: false,
      showewm: false,
      tabIndex: 0,
      tabList: [
        {
          name: "资料",
        },
        {
          name: "生平介绍",
        },
      ],
      tab2Index: 0,
      tab2List: [
        {
          name: "风格设置",
          key: "style",
        },
        {
          name: "相框样式",
          key: "tablet",
        },
        {
          name: "生平介绍",
          key: "remark",
        },
      ],
      styleList: [],
      imgSrc: "",
      imgList: [],
      videoSrc: "",
      videoList: [],
      giftMemoList: [],
      giftList: [],
      fragrantList: [],
      hounsList: [],
      smoList: [],
      commentList: [],
      gordList: [],
      gotList: [],
      words: "",
      showBuygift: false,
      showOpenGift: true,
      openMusic: false,
      showVideo: false,
      autoPlay: true,
      dioLogTop: "20vh",
      lifeHis: "",
      danmuScorll: 0,
      styleParams: {
        pageNum: 1,
        pageSize: 1000,
      },
      scaleNum: 1,
      indexNum: 0,
      orderQueryTimer: null,
      dieUser: {},
      userId: null,
      giftUrl: "",
      showGiftGif: false,
      memoNum: 1,
      classOption: {
        autoPlay: true,
        direction: 1,
        hoverStop: false,
        limitMoveNum: 10,
      },
      dmList: [],
      idx: 3,
      clist: [], // c位的弹幕队列
      bulletlist: [], // 当前正在执行的
      ifFollow: false,
      fireNum: 0,
      tributeList: [],
      showTap: false,
      showTalk: true,
      showZxewm: false,
      zhifuList: [],
      tabBotList: [],
      tabCheckIndex: 0,
      allGord: [],
      showBuyBox: false,
      buyGift: {},
      buyIndex: 0,
      showTriNum: true,
      showReport: false, //举报弹窗
      action:
        process.env.BASE_URL.replace("subapp/sub-pc", "mmwz-app") +
        "api/video/uploadUrl",
      header: {
        Authorization: "Bearer " + getToken(),
      },
      form: {},
      reasonList: [],
      describe: "",
      showInfo: "",
      isAnimating: false,
      showQuNum: false,
      requestStatus: false,
      quGiftList: [],
      quIndex: 0,
      showDeep: true,
      giftRankList: [],
      report: {
        describe: null,
      },
      fileList: [],
      selectedValues: [],
      reportType: {},
      uploadedImages: [],
      consumerId: null, //用户ＩＤ
      tabletStyleId: 1,
      capitalizations: [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
      ],
      isPreview: false,
      showPreviews: [], // 用来存储每个图片是否显示预览信息的状态
      previewImg: null,
      enlarge: false,
      checkBoxColor: 1,
      showBooktxt: false,
      bookTime: null,
      bookGift: "",
      backgroundImageUrl:
        "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/book.gif",
      showBurnimg: false,
      //购物车
      gwcList: [],
      gwcCount: 0,
      showGwc: false,
      dropIt: 0,
      gwcCheck: false,
      gwcData: [],
      myCart: [],
      cartTotal: 0,
      cartPageNo: 1,
      interGif: null,
      stickTime: false,
      howMuch: 0,
    };
  },
  computed: {
    giftListLeft() {
      return this.giftList ? 225 - (this.giftList.length * 46) / 2 : 0;
    },
    totalGiftCount() {
      return this.gotList
        .map((t) => t.giftCount)
        .reduce((t1, t2) => t1 + t2, 0);
    },

    isComputed() {
      if (this.report.describe && this.reportType.dictValue) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    showGiftGif(n, i) {
      // if (n == true && i == false) {
      //   setTimeout(() => {
      //     this.showGiftGif = false;
      //   }, 3500);
      // }
    },
    showBurnimg(n) {},
    memoNum(n, i) {},
    commentList(n, i) {},
    showGwc(n, i) {
      if (!n) {
        this.gwcCheck = false;
        this.gwcList.map((e) => {
          e.check = false;
        });
      }
    },
    giftUrl(n, i) {},
  },
  created() {
    this.getReportfList();
    this.danmuScorll = new Date().getTime();
    this.screenWidth = 0;
    this.screenHeight = 0;
    this.scaleNum = 0;
    this.$parent.ifshowmainTopBg = false;
    let data = this.getViewportSize();
    this.screenWidth = data.pageWidth;
    this.screenHeight = data.pageHeight;
    this.scaleNum = this.screenWidth / 1920;
    let id = this.$route.query.id;
    this.userId = id;
    if (id) {
      this.getGiftsHalls({ id: id, secondType: 2 });
      if (this.$route.query.detail) {
        this.getHalldetails({ id: id, detail: true });
      } else {
        this.getHalldetails({ id: id });
      }
      this.seeView();
      this.getGifts();
      this.getGiftList();
      this.getGiftTypes();
      this.getGiftranks();
      this.getZfList();
      //购物车
      this.getCartCounts();
      this.getCartLists();
    }

    this.styleParams.hallId = id;
    this.orderCreate.refId = id;
    this.queryStyle();
    this.$nextTick(() => {
      this.$el
        .querySelector("#bottoms")
        .scrollIntoView({ block: "start", behavior: "smooth" });
    });
  },
  mounted() {
    //this.scrollInit();
    window.addEventListener("resize", (res) => {});
    window.addEventListener("popstate", this.handleBackButton);
    document.onselectstart = new Function("event.returnValue=false");
  },
  beforeDestroy() {
    setTimeout(() => {
      window.removeEventListener("popstate", this.handleBackButton);
    }, 300);
  },
  methods: {
    //购物车
    openGwc() {
      this.cartPageNo = 1;
      this.myCart = [];
      this.getmyCartList();
      setTimeout(() => {
        if (!this.showGiftGif) {
          this.showGwc = !this.showGwc;
          if (this.showGwc == true) {
            this.showBuygift = false;
          }
        }
      }, 400);
    },
    loadScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 当滚动到底部时触发加载更多
      if (
        scrollTop + clientHeight >= scrollHeight - 5 &&
        this.cartTotal > this.cartPageNo * 6
      ) {
        this.cartPageNo++;
        this.getmyCartList();
        // 留出5px的边距
      }
    },
    getmyCartList() {
      let data = {
        id: this.userId,
        self: true,
        pageNo: this.cartPageNo,
        pageSize: 20,
        secondType: 2,
      };
      getCartListforme(data).then((res) => {
        this.myCart = [...this.myCart, ...res.data.result.records];
        this.cartTotal = res.data.result.total;
      });
    },
    delGwc() {
      if (this.gwcData?.length > 0) {
        let arr = [];
        arr = this.gwcData.map((e) => {
          return e.id;
        });
        let data = {
          ids: arr.toString(),
        };
        delCartItem(data).then((res) => {
          this.getCartLists();
        });
      } else {
        this.$message.error("请先选择一个供品！");
      }
    },
    delGwcsingle(e) {
      let data = {
        ids: e.id,
      };
      delCartItem(data).then((res) => {
        this.getCartLists();
      });
    },
    gwcPlusPrice() {
      if (this.gwcData?.length > 0) {
        let arr = [];
        arr = this.gwcData.map((e) => {
          return e.currentOption.price;
        });
        let num = arr.reduce((e, a) => e + a);
        return num;
      } else {
        return 0;
      }
    },
    changePos(e, i) {
      if (e.disabled == 1) {
        return;
      }
      e.posCheck = !e.posCheck;
      this.gwcList.map((a, j) => {
        if (i == j) {
        } else {
          a.posCheck = false;
        }
      });
      this.$forceUpdate();
    },
    optChecks(e, a, ai) {
      a.optCheck = true;
      e.options.map((c, ci) => {
        if (ci == ai) {
        } else {
          c.optCheck = false;
        }
      });
      e.currentOption = a;
      e.posCheck = false;
      this.$forceUpdate();
    },
    getCartCounts() {
      let data = {
        hallId: this.userId,
        secondType: 2,
      };
      getCartCount(data).then((res) => {
        this.gwcCount = res.data.result;
      });
    },
    getCartLists() {
      let data = {
        hallId: this.userId,
        secondType: 2,
      };
      getCartList(data).then((res) => {
        this.gwcData = [];
        this.gwcCheck = false;
        this.gwcList = res.data.result;
        this.gwcList.map((e) => {
          e.check = false;
          e.posCheck = false;
          e.options.map((a, i) => {
            if (e?.currentOption?.time == a?.time) {
              if (e?.options[i]?.time == a?.time) {
                if (i == 0) {
                  a.optCheck = true;
                  // e.currentOption.index = 0;
                } else {
                  a.optCheck = false;
                }
              } else {
                a.optCheck = true;
              }
            } else {
              //  e.currentOption.index = i;
              a.optCheck = false;
            }
          });
        });
      });
    },
    toCheckAllGwc(e) {
      if (e == 0) {
        this.gwcCheck = true;
        this.gwcList.map((e) => {
          if (e.disabled == 2) {
            e.check = true;
          }
        });
      } else {
        this.gwcCheck = false;
        this.gwcList.map((e) => {
          if (e.disabled == 2) {
            e.check = false;
          }
        });
      }
      this.gwcData = this.gwcList.filter((item) => {
        return item.check == true;
      });
    },
    tocheckGwc(e) {
      if (e.disabled == 1) {
        return;
      }
      e.check = !e.check;
      this.gwcData = this.gwcList.filter((item) => {
        return item.check == true;
      });
      if (this.gwcData.length == this.gwcList.length) {
        this.gwcCheck = true;
      } else {
        this.gwcCheck = false;
      }
      this.$forceUpdate();
    },
    toCart() {
      let data = {
        hallId: this.userId,
        giftId: this.buyGift.id,
        optionDay: this.buyGift.giftValueOptions[this.buyIndex].time,
      };
      toaddCartList(data).then((res) => {
        this.$message({
          showClose: true,
          message: "加入购物车" + res.data.message,
          type: "success",
        });
        this.buyIndex = 0;
        this.showBuyBox = false;
        this.getCartLists();
      });
    },
    toCheckOut() {
      if (this.gwcData?.length == 0) {
        this.$message.error("请选择商品！");
      } else {
        let num = this.gwcPlusPrice();
        this.howMuch = num;
        if (num > 0) {
          this.orderCreate.items = this.gwcData.map((e) => {
            return {
              itemId: e.id,
              itemType: 3,
              optionIndex: e.currentOption.time,
            };
          });
          this.showPayDia = true;
        } else {
          this.toCartFree();
        }
      }
    },
    toCartFree() {
      let arr = this.gwcData.map((e) => {
        return {
          id: e.id,
          optionDay: e.currentOption.time,
        };
      });
      toCartGiftforFree(arr).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "购买" + res.data.msg,
            type: "success",
          });
        }
        this.showGwc = false;
        let arr = this.gwcData.filter((e, i) => {
          if (e.giftPicture) {
            e.giftPicture = `${e.giftPicture}?t=${new Date().getTime()}${i}`;
            return e.giftPicture;
          }
        });
        if (arr?.length > 0) {
          this.toPlayAni(arr);
        }
        setTimeout(() => {
          this.getGiftsHalls({ id: this.userId, secondType: 2 });
          this.getGifts();
          this.getGiftList();
          this.getGiftranks();
          this.getCartLists();
          this.getFireNum();
          this.getmyCartList();
        }, 1000);
      });
    },
    toPlayAni(arr) {
      this.stickTime = true;
      this.showGiftGif = true;
      arr.forEach((item, index) => {
        setTimeout(() => {
          if (arr.length == index + 1) {
            this.showBurnimg = true;
            this.giftUrl = item.giftPicture;
          } else {
            this.showBurnimg = true;
            this.giftUrl = item.giftPicture;
            setTimeout(() => {
              this.showBurnimg = false;
            }, 1000);
          }
        }, index * 2000); // 使用循环索引来确定延迟时间
      });
      this.backgroundImageUrl =
        this.backgroundImageUrl + `?${new Date().getTime()}`;
      var now = new Date();
      var year = now.getFullYear(); //年
      var month = now.getMonth() + 1; //月
      var day = now.getDate(); //日
      this.bookTime = year + "年" + month + "月" + day + "日";
      this.bookGift = arr
        .map((e, i) => {
          if (i <= 5) {
            return e.giftName + "*1";
          }
        })
        .toString(); //this.buyGift.giftName;
      if (arr?.length >= 5) {
        this.bookGift = this.bookGift + "等等";
      }
      setTimeout(() => {
        this.showBooktxt = true;
      }, 2000);
      setTimeout(() => {
        this.stickTime = false;
        this.showBurnimg = false;
      }, arr.length * 2000);
    },
    getFireNum() {
      let data = {
        itemId: this.userId,
        bizType: 16,
      };
      getSpecialCount(data).then((res) => {
        this.fireNum = res.data.result;
      });
    },

    toWorship() {
      this.$router.replace({
        path: "/worship",
        query: { id: this.userId, detail: true },
      });
    },
    cosName(e) {
      if (e) {
        if (e?.length > 4) {
          return e.slice(0, 4) + "之墓";
        } else {
          return e + "之墓";
        }
      }
    },
    boxColorCheck(e) {
      if (!this.dieUser.picture) {
        this.$message.error({
          showClose: true,
          message: "请在个人中心-管理纪念馆处修改纪念馆上传逝者图片",
          duration: 4000,
        });
        return;
      }
      if (
        (!this.dieUser.birthDay && e !== 1) ||
        (!this.dieUser.dieDay && e !== 1)
      ) {
        this.$message.error({
          showClose: true,
          message: "请先完善出生日期和逝世日期",
        });
        return;
      }
      this.checkBoxColor = e;
    },
    // 初始化与绑定监听事件方法
    scrollInit() {
      // 获取要绑定事件的元素
      const nav = document.getElementById("tabItWheel");
      var flag; // 鼠标按下
      var downX; // 鼠标点击的x下标
      var scrollLeft; // 当前元素滚动条的偏移量
      nav.addEventListener("mousedown", function (event) {
        flag = true;
        downX = event.clientX; // 获取到点击的x下标
        scrollLeft = this.scrollLeft; // 获取当前元素滚动条的偏移量
      });
      nav.addEventListener("mousemove", function (event) {
        if (flag) {
          // 判断是否是鼠标按下滚动元素区域
          var moveX = event.clientX; // 获取移动的x轴
          var scrollX = moveX - downX; // 当前移动的x轴下标减去刚点击下去的x轴下标得到鼠标滑动距离
          this.scrollLeft = scrollLeft - scrollX; // 鼠标按下的滚动条偏移量减去当前鼠标的滑动距离
        }
      });
      // 鼠标抬起停止拖动
      nav.addEventListener("mouseup", function () {
        flag = false;
      });
      // 鼠标离开元素停止拖动
      nav.addEventListener("mouseleave", function (event) {
        flag = false;
      });
    },
    handleUploadChange(file, fileList) {
      this.fileList = fileList;
    },

    getReportfList() {
      reportfList("report_type").then((res) => {
        this.reasonList = res.data.data;
      });
    },

    getZfList() {
      getDictTypeDate("zfkey").then((r) => {
        let a = {
          name: "支付宝",
          paymentType: 1,
          check: false,
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/ali.png",
        };
        let b = {
          name: "微信",
          paymentType: 3,
          check: false,
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/wechat.png",
        };
        r.data.data.map((e) => {
          if (e.dictValue == a.paymentType && e.status == 0) {
            this.zhifuList.push(a);
          }
          if (e.dictValue == b.paymentType && e.status == 0) {
            this.zhifuList.push(b);
          }
        });
      });
    },
    fureshFuc: debounce(function () {
      this.getGiftsHalls({ id: this.userId, secondType: 2 });
      this.getGifts();
      this.getGiftList();
      this.getGiftranks();
    }),
    mouseover(e) {
      e.check = true;
      this.$forceUpdate();
    },
    mouseout(e) {
      e.check = false;
      this.$forceUpdate();
    },
    toBuyGift(e) {
      if (!this.showGiftGif) {
        this.showBuyBox = true;
        this.buyGift = e;
        this.checkGift(e);
      }
    },
    checkTab(e, i) {
      this.tabCheckIndex = i;
      if (i == 0) {
        this.gordList = this.allGord;
      } else {
        this.gordList = this.allGord.filter((t) => {
          return t.typeId == e.id;
        });
      }
    },
    getGiftTypes() {
      let data = {
        pageNum: 1,
        pageSize: 200,
        secondType: 2,
      };
      getGiftType(data).then((res) => {
        this.tabBotList = [{ name: "全部" }, ...res.data.result.records];
      });
    },
    getGiftranks() {
      getGiftrank({ id: this.userId, secondType: 2 }).then((res) => {
        this.giftRankList = res.data.result;
      });
    },
    getGiftList() {
      let data = {
        id: this.userId,
        secondType: 2,
      };
      getGiftList(data).then((res) => {
        this.tributeList = res.data.result;
      });
    },
    followHall() {
      if (!localStorage.getItem("token")) {
        this.$router.push("login");
        return;
      }
      let data = {
        bizType: 16,
        itemId: this.userId,
        key: "FOCUS",
      };
      actionAll(data).then((res) => {
        this.ifFollow = !this.ifFollow;
        this.showBuygift = false;
        this.getGiftsOnlines();
      });
    },
    changeZhifuTap(e) {
      e.check = !e.check;
      this.orderCreate.paymentType = e.paymentType;
      this.zhifuList.forEach((t) => {
        if (t.name != e.name) {
          t.check = false;
        }
      });
    },
    getGifts() {
      let data = {
        id: this.userId,
      };
      getGiftDie(data).then((res) => {
        this.smoList = res.data.result;
        this.smoList.map((item, index) => {
          if (item.giftViewType == "fruits") {
            this.giftList = item.records;
          } else if (item.giftViewType == "fragrant") {
            this.fragrantList = [];
            if (item.records?.length > 0) {
              this.fragrantList.push(
                JSON.parse(JSON.stringify(item.records[0]))
              );
              this.fragrantList.push(
                JSON.parse(JSON.stringify(item.records[0]))
              );
              this.fragrantList.push(
                JSON.parse(JSON.stringify(item.records[0]))
              );
              this.fragrantList.push(
                JSON.parse(JSON.stringify(item.records[0]))
              );
            }
          } else if (item.giftViewType == "houns") {
            this.hounsList = item.records;
          }
        });
      });
    },
    editLifeHis(item) {
      if (item.key === "remark") {
        let data = {
          ...this.dieUser,
          remark: this.lifeHis,
        };
        editHall(data).then((res) => {
          this.getHalldetails({ id: this.userId });
          this.showgl = false;
        });
      } else {
        tabletStyleSet(this.userId, this.checkBoxColor).then((r) => {
          this.getHalldetails({ id: this.userId });
          this.showgl = false;
        });
      }
    },
    seeView() {
      let data = {
        bizType: 16,
        itemId: this.userId,
        key: "VIEW",
      };
      actionAll(data).then((res) => {});
    },
    handleBackButton() {
      this.$parent.ifshowmainTopBg = true;
      // 用户点击了浏览器返回按钮
      // 在这里可以执行你需要的逻辑，比如提示用户、重定向到其他页面等
    },
    getGiftsOnlines() {
      getGiftsOnline({ hallId: this.userId, secondType: 2 }).then((res) => {
        this.giftMemoList = res.data.result;
        this.allGord = res.data.result;
        this.gordList = this.allGord;
      });
    },
    getGiftsHalls(e) {
      getGiftsHall(e).then((res) => {
        this.gotList = res.data.result;
        if (this.gotList.length > 3) {
          this.indexNum = 3;
        } else if (this.gotList.length <= 3) {
          this.indexNum = this.gotList.length;
        }
      });
    },
    getHallattas(e) {
      getHallatta(e).then((res) => {
        if (e.attaType == 1) {
          this.imgList = res.data.result;
        } else {
          this.videoList = res.data.result;
        }
      });
    },
    cosDate(e) {
      if (e?.length > 0) {
        let str = e;
        let index = str.indexOf("-");
        let result = str.substring(0, index);
        return result;
      }
    },
    getHalldetails(e) {
      getHalldetail(e).then((res) => {
        this.consumerId = res.data.result.userId;
        this.checkBoxColor = res.data.result.tabletStyleId;
        this.tabletStyleId = res.data.result.tabletStyleId;
        this.ifFollow = res.data.result.actionStat.isFocus;
        this.getGiftsOnlines();
        this.dieUser = res.data.result;
        this.fireNum = this.dieUser.actionStat.totalSpecialCount;
        if (this.dieUser.remark) {
          this.lifeHis = this.dieUser.remark;
        }
        if (this.dieUser.canDelete === 0) {
          this.tab2List = [
            {
              name: "风格设置",
              key: "style",
            },
          ];
        } else {
          this.tab2List = [
            {
              name: "风格设置",
              key: "style",
            },
            {
              name: "相框样式",
              key: "tablet",
            },
            {
              name: "生平介绍",
              key: "remark",
            },
          ];
        }
      });
    },
    launchFullScreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    getViewportSize() {
      var pageWidth = window.innerWidth,
        pageHeight = window.innerHeight;
      // 判断浏览器是否支持innerWidth
      if (typeof pageWidth !== "number") {
        // 文档渲染模式是标准模式
        if (document.compatMode == "CSS1Compat") {
          pageWidth = document.documentElement.clientWidth;
          pageHeight = document.documentElement.clientHeight;
        } else {
          // 文档渲染模式是混杂模式或怪异模式
          pageWidth = document.body.clientWidth;
          pageHeight = document.body.clientHeight;
        }
      }
      return {
        pageWidth,
        pageHeight,
      };
    },
    goBack() {
      this.$parent.ifshowmainTopBg = true;
      this.$router.go(-1);
    },
    checkGift(e, i) {
      if (!this.showGiftGif) {
        this.giftUrl = e.giftAnimation;
        this.$forceUpdate();
      }
    },
    toBuy() {
      this.showBooktxt = false;
      if (this.buyGift.giftValueOptions[this.buyIndex].price > 0) {
        this.howMuch = this.buyGift.giftValueOptions[this.buyIndex].price;
        this.orderCreate.items = [
          {
            itemId: this.buyGift.id,
            itemType: 1,
            optionIndex: this.buyIndex,
          },
        ];
        this.showPayDia = true;
      } else {
        sendGift({
          giftId: this.buyGift.id,
          bizType: 3,
          sendTargetId: this.userId,
          optionIndex: this.buyIndex,
        }).then((r) => {
          if (r.data.code === 200) {
            // if (!this.giftUrl) {
            //   this.showGiftGif = false;
            // } else {
            //   this.giftUrl = this.giftUrl + `?${new Date().getTime()}`;
            //   this.showGiftGif = true;
            // }
            this.giftUrl = this.buyGift.giftPicture;
            this.showGiftGif = true;
            this.showBurnimg = true;
            this.backgroundImageUrl =
              this.backgroundImageUrl + `?${new Date().getTime()}`;
            var now = new Date();
            var year = now.getFullYear(); //年
            var month = now.getMonth() + 1; //月
            var day = now.getDate(); //日
            this.bookTime = year + "年" + month + "月" + day + "日";
            this.bookGift = this.buyGift.giftName + "*1";
            setTimeout(() => {
              this.showBooktxt = true;
              this.showBurnimg = false;
            }, 2000);
            this.$message({
              showClose: true,
              message: "成功送出" + 1 + "个" + this.buyGift.giftName + "！",
              type: "success",
            });
            //this.buyGift.giftValueOptions[this.buyIndex].time
            this.getGiftsHalls({ id: this.userId, secondType: 2 });
            this.getGifts();
            this.getGiftList();
            this.getGiftranks();
            this.getmyCartList();
            this.fireNum += this.buyGift.giftValueOptions[this.buyIndex].value;
          } else {
            this.$message.error(r.data.msg);
          }
          this.buyIndex = 0;
        });
      }
      this.showBuyBox = false;
      this.showBuygift = false;
    },
    toCloseBuy() {
      this.showBuygift = false;
      // this.gordList.map((item, index) => {
      //   item.check = false;
      // });
    },
    openMusicfuc() {
      this.openMusic = !this.openMusic;
      if (this.openMusic == true) {
        this.$refs.musicFile.play();
      } else {
        this.$refs.musicFile.pause();
      }
    },
    toPlayVideo(e) {
      getVideoById(e.attaSource).then((res) => {
        this.videoSrc = res.data.result.playInfoList.playInfo[0].playURL;
        this.showVideo = true;
        this.$nextTick(() => {
          this.$refs.videoDom.load();
          this.autoPlay = true;
        });
      });
    },
    handleClose() {
      if (this.$refs.videoDom) {
        this.$nextTick(() => {
          this.$refs.videoDom.pause();
          this.showVideo = false;
        });
        this.autoPlay = false;
      }
    },
    checkUsed(e) {
      if (e.isUsing) {
        return;
      }
      let data = {
        hallId: this.userId,
        styleId: e.id,
      };
      //TODO 权限判断
      if (e.isHave || e.price === 0) {
        styleSet(data).then((r) => {
          if (!r || r.code !== 200) {
            return;
          }
          e.isUsing = !e.isUsing;
          this.styleList.map((item, index) => {
            if (item.id !== e.id) {
              item.isUsing = false;
            }
          });
          this.getHalldetails({ id: this.userId });
        });
      } else {
        this.orderCreate.items = [
          {
            itemCount: 1,
            itemId: e.id,
            itemType: 2,
          },
        ];
        this.showPayDia = true;
      }
    },
    orderPre() {
      let ifCheck = this.zhifuList.filter((item) => {
        return item.check == true;
      });
      if (ifCheck.length == 0) {
        this.orderCreate.paymentType = null;
        this.$message({
          showClose: true,
          message: "请选择一种支付方式！",
          type: "error",
        });
        return;
      }
      orderPre(this.orderCreate).then((r) => {
        if (r.data.code !== 200) {
          this.$message.error(r.data.msg);
        } else {
          this.orderCreate.step = 2;
          this.orderCreate.tradeNo = r.data.data.orderNo;
          if (this.orderCreate.paymentType === 3) {
            this.orderCreate.outBody = r.data.data.outBody;
          } else {
            this.orderCreate.outBody = Base64.decode(r.data.data.outBody);
          }
          this.clearTimer();
          this.orderQueryTimer = setInterval(() => {
            this.orderQueryStatus(this.orderCreate.tradeNo);
          }, 1000);
        }
      });
    },
    closeOrder() {
      this.buyIndex = 0;
      this.showPayDia = false;
      this.orderCreate.step = 1;
      this.orderCreate.items = [];
      this.orderCreate.tradeNo = null;
      this.clearTimer();
    },
    orderQueryStatus(code) {
      this.showBooktxt = false;
      if (!code) {
        return;
      }
      orderQueryStatus(code).then((r) => {
        if (r.data.data === 4) {
          // this.$message.success("支付成功");
          if (this.orderCreate.items[0].itemType === 2) {
            this.styleList = [];
            this.queryStyle();
          } else {
            if (this.gwcData?.length > 0) {
              this.showGwc = false;
              let arr = this.gwcData.filter((e, i) => {
                if (e.giftPicture) {
                  e.giftPicture = `${
                    e.giftPicture
                  }?t=${new Date().getTime()}${i}`;
                  return e.giftPicture;
                }
              });
              if (arr?.length > 0) {
                this.toPlayAni(arr);
              }
              setTimeout(() => {
                this.getGiftsHalls({ id: this.userId, secondType: 2 });
                this.getGifts();
                this.getGiftList();
                this.getGiftranks();
                this.getCartLists();
                this.getFireNum();
                this.getmyCartList();
              }, 1000);
            } else {
              this.gotList = [];
              this.giftUrl = this.buyGift.giftPicture;
              this.showGiftGif = true;
              this.showBurnimg = true;
              this.backgroundImageUrl =
                this.backgroundImageUrl + `?${new Date().getTime()}`;
              var now = new Date();
              var year = now.getFullYear(); //年
              var month = now.getMonth() + 1; //月
              var day = now.getDate(); //日
              this.bookTime = year + "年" + month + "月" + day + "日";
              this.bookGift = this.buyGift.giftName + "*1";
              setTimeout(() => {
                this.showBooktxt = true;
                this.showBurnimg = false;
              }, 2000);
              this.$message({
                showClose: true,
                message: "成功送出" + 1 + "个" + this.buyGift.giftName + "！",
                type: "success",
              });
              setTimeout(() => {
                this.getGiftsHalls({ id: this.userId, secondType: 2 });
                this.getGifts();
                this.getGiftList();
                this.getGiftranks();
                this.getmyCartList();
              }, 1000);
              this.fireNum +=
                this.buyGift.giftValueOptions[this.buyIndex].value;
              this.buyIndex = 0;
            }
            this.closeOrder();
          }
        } else if (r.data.data === 3 || r.data.data === 5) {
          this.$message.error("订单失效，请刷新页面重新支付");
          this.closeOrder();
        }
      });
    },
    orderPreStep() {
      this.orderCreate.step = 1;
      this.clearTimer();
    },
    clearTimer() {
      if (this.orderQueryTimer) {
        clearInterval(this.orderQueryTimer);
      }
    },
    queryStyle() {
      styleList(this.styleParams).then((r) => {
        this.styleList = r.data.rows;
      });
    },
    getVideo(e, i) {
      this.tabIndex = i;
      if (e.name == "视频") {
        this.getHallattas({ refId: this.userId, attaType: 2 });
      } else if (e.name == "相册") {
        this.getHallattas({ refId: this.userId, attaType: 1 });
      }
    },
    toMin() {
      if (this.memoNum > 1) {
        this.memoNum--;
      }
    },
    toPlus() {
      if (this.memoNum < 10) {
        this.memoNum++;
      }
    },
    unitConverter(num) {
      if (num) {
        num = num.toString().split("."); // 分隔小数点
        var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
        var res = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          if (i % 3 === 0 && i !== 0) {
            res.push(","); // 添加分隔符
          }
          res.push(arr[i]);
        }
        res.reverse(); // 再次倒序成为正确的顺序

        if (num[1]) {
          if (num[1].length < 2) {
            // 如果有小数的话添加小数部分
            res = res.join("").concat("." + num[1] + "0");
          } else if (num[1].length > 2) {
            let data = num[1].substring(0, 2);
            // 如果有小数的话添加小数部分
            res = res.join("").concat("." + data);
          } else {
            res = res.join("").concat("." + num[1]);
          }
        } else {
          res = res.join("").concat("." + "00");
        }
      } else {
        res = "0.00";
      }
      return res;
    },
    unitConverterPlus(num) {
      if (num) {
        num = num.toString().split("."); // 分隔小数点
        var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
        var res = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          if (i % 3 === 0 && i !== 0) {
            res.push(","); // 添加分隔符
          }
          res.push(arr[i]);
        }
        res.reverse(); // 再次倒序成为正确的顺序

        if (num[1]) {
          if (num[1].length < 2) {
            // 如果有小数的话添加小数部分
            res = res.join("").concat("." + num[1] + "0");
          } else if (num[1].length > 2) {
            let data = num[1].substring(0, 2);
            // 如果有小数的话添加小数部分
            res = res.join("").concat("." + data);
          } else {
            res = res.join("").concat("." + num[1]);
          }
        } else {
          res = res.join(""); //.concat("." + '00');
        }
      } else {
        res = "0"; //'0.00'
      }
      return res;
    },
    moneyFormat(arg) {
      arg = parseInt(Number(arg));

      if (arg.toString().length >= 13) {
        // return arg/1000000000000+"万亿"
        const moneys = arg / 1000000000000;
        const realVal = parseInt(parseFloat(moneys) * 100) / 100;
        return realVal + "万亿";
      } else if (arg.toString().length >= 9) {
        const moneys = arg / 100000000;
        const realVal = parseInt(parseFloat(moneys) * 100) / 100;
        return realVal + "亿";
      } else if (arg.toString().length >= 8) {
        const moneys = arg / 10000000;
        const realVal = parseInt(parseFloat(moneys) * 100) / 100;
        return realVal + "千万";
      } else if (arg.toString().length >= 4) {
        const moneys = arg / 10000;

        const realVal = parseInt(parseFloat(moneys) * 100) / 100; //parseInt(moneys).toFixed(2);
        return realVal + "万";
      }
    },
    closeGift() {
      document.getElementById("scrollItem").scrollTop = 0;
      this.showOpenGift = true;
      this.showTap = false;
    },
    changeTap() {
      document.getElementById("scrollItem").scrollTop = 0;
      this.showTap = !this.showTap;
      this.showDeep = !this.showDeep;
    },
    changeTapPlus() {
      this.showTap = !this.showTap;
      this.showDeep = !this.showDeep;
      this.showOpenGift = false;
    },
    getTime(e) {
      const date = new Date(e);
      if (date.getTime() < Date.now()) {
        return "过期";
      } else {
        const timestamp1 = Date.now();
        const timestamp2 = new Date(e).getTime();
        let a = this.timeDiffToDaysHoursFormat(timestamp1, timestamp2);
        if (a == "0天0小时") {
          return "即将过期";
        } else {
          return a;
        }
      }
    },
    timeDiffToDaysHoursFormat(timestamp1, timestamp2) {
      const millisecondsDiff = timestamp2 - timestamp1;
      const days = Math.floor(millisecondsDiff / 86400000);
      const remainingHours = Math.floor(
        (millisecondsDiff % 86400000) / 3600000
      );
      return `${days}天${remainingHours}小时`;
    },
    deepTime(e) {
      let date = new Date(e);
      var month = this.padZero(date.getMonth() + 1); // 月份是从0开始的
      var day = this.padZero(date.getDate());
      var hours = this.padZero(date.getHours());
      var minutes = this.padZero(date.getMinutes());
      return month + "-" + day + " " + hours + ":" + minutes;
    },
    padZero(num) {
      return num < 10 ? "0" + num : num;
    },
    toUser(e) {
      this.showZxewm = true;
    },
    beforeUpload(file) {
      if (this.fileList.length >= 4) {
        this.$message.warning("最多只能上传3张照片");
        return false;
      }
      return true;
    },
    // 点击举报
    onReport() {
      this.showReport = true;
    },

    //举报确认按钮
    saveForm() {
      if (!this.isComputed) {
        return;
      }

      let curData = this.fileList.map((item) => item.response);
      this.uploadedImages = curData.map((item) => item.url);

      let data = {
        bizType: 16,
        key: "REPORT",
        itemId: this.$route.query.id,
        userId: this.consumerId,
        type: this.reportType.dictValue,
        comment: this.report.describe,
        mediaUrls: this.uploadedImages.toString(),
      };

      reportSubmit(data).then((res) => {
        this.$message.success("举报成功");
        setTimeout(() => {
          this.reportType = {};
          this.report.describe = null;
          this.fileList = [];
          this.showReport = false;
        }, 1000);
      });
    },

    handleClose() {
      this.showReport = false;
    },
    changeType(item) {
      this.reportType = item;
    },
    handleAvatarSuccess(res, file, fileList) {
      this.form.picture = res.fileName;
      this.fileList = fileList; // 更新文件列表
      if (this.fileList.length === 3) {
        let upload = this.$refs.upload.$el;
        const uploads = upload.querySelector(".el-upload--picture-card");
        uploads.style.display = "none";
      }
    },
    onRemove(file, fileList) {
      this.fileList = fileList;
      if (this.fileList.length < 3) {
        let upload = this.$refs.upload.$el;
        upload.style.display = "flex";
        const uploads = upload.querySelector(".el-upload--picture-card");
        uploads.style.display = "block";
      }
    },
    mouseCover() {
      if (this.form.picture) {
        setTimeout(() => {
          this.showInfo = true;
        }, 300);
      }
    },

    mouseOut() {
      if (this.form.picture) {
        setTimeout(() => {
          this.showInfo = false;
        }, 300);
      }
    },
    changeDate(e) {
      if (e == 0) {
        if (this.form.deadDay !== "") {
          this.form.noDie = false;
        }
      } else {
        if (this.form.birthDay !== "") {
          this.form.noBirth = false;
        }
      }
    },
    clearDate(e) {
      if (e == 0) {
        this.form.noDie = !this.form.noDie;
        if (this.form.noDie == true) {
          this.form.dieDay = null;
        }
      } else {
        this.form.noBirth = !this.form.noBirth;
        if (this.form.noBirth == true) {
          this.form.birthDay = null;
        }
      }
    },

    showPreview(val, index) {
      if (val.price != 0) {
        this.$set(this.showPreviews, index, true);
      }
    },
    hidePreview() {
      this.showPreviews = [];
    },
    onPreview(val) {
      this.previewImg = val.url;
      this.enlarge = true;
    },
  },
};
</script>
<style  lang="scss" scoped>
.animate {
  animation: exampleAnimation 1s forwards;
}

@keyframes exampleAnimation {
  0% {
    opacity: 1;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    transform: translateY(-30px);
  }
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #579487;
  color: #fff;
}
:deep .el-dialog {
  background: #f4f5f7;
  border-radius: 10px;
}
:deep .avatar-uploader {
  text-align: left;
  margin-left: 20px;
}
:deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
:deep .avatar-uploader .el-upload:hover {
  border-color: #45796e;
}
:deep .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  /* height: 50px;
  line-height: 50px; */
  margin-top: 30px;
  text-align: center;
  border-radius: 5px;
}
:deep .avatar {
  width: 150px;
  height: 150px;
  display: block;
  border-radius: 10px;
  object-fit: cover;
}
</style>
<style lang="scss" scoped>
@import "./outer.scss";
.inpTextarea {
  width: 451px;
  height: 80px;
  max-width: 451px;
  max-height: 80px;
  resize: none;
  border-radius: 10px;
  background: #23190b;
  color: #fff;
  box-sizing: border-box;
  padding: 10px 20px;
  font-size: 16px;
}
.box {
  width: 100%;
  min-width: 1200px;
  height: 1080px;
  max-height: 1080px;
  min-height: 500px;
  margin: 0 auto;
  position: relative;
  :deep .el-input__inner {
    height: 46px;
    border-radius: 10px;
    background: #23190b;
    border: 1px solid #e0c499;
    color: #fff;
  }
  :deep .el-input__inner:focus {
    border-color: #e0c499;
  }
  :deep .el-textarea__inner {
    border: none !important;
    background: transparent;
    color: #323232;
    font-size: 16px;
  }

  :deep .el-textarea__inner:focus {
    border: none !important;
  }

  :deep .el-textarea__inner:hover {
    border: none !important;
  }
  :deep textarea::placeholder {
    color: #8a8a8a; /* 修改为您想要的颜色代码 */
  }
  .boxIt {
    background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/outer-bg.png")
      no-repeat;
    background-size: 100% 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    z-index: 1;
  }
  .rightBox {
    position: absolute;
    top: 58px;
    right: 112px;
    z-index: 99;
    display: flex;
  }
  .quitBox {
    width: 111px;
    line-height: 54px;
    font-size: 20px;
    color: #f7f7f7;
    border: 3px solid #ffffff73;
    background: #00000075;
    border-radius: 10px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 30px;
  }
  .wornBox {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    background: #00000075;
    color: #f5f5f5;
    font-size: 16px;
    line-height: 54px;
    margin-right: 168px;
    cursor: pointer;
  }
  .quitMan {
    //min-width: 382px;
    height: 187px;
    font-size: 20px;
    color: #b6b6b6;
    border: 3px solid #ffffff73;
    background: #00000075;
    border-radius: 10px;
    z-index: 100;
    position: absolute;
    top: 150px;
    left: 101px;
  }

  .leftIcon {
    width: 11.25px;
    height: 21px;
    flex: none;
    margin-right: 18px;
  }
}
#container {
  width: 100vw;
  height: 100vh;
}
.hounBox {
  width: 48px;
  height: 56px;
  z-index: 103;
  margin: 0 auto;
  position: absolute;
  top: 585px;
  left: -14px;
  right: 0;
  display: flex;
  justify-content: center;
}
.houns {
  width: 92px;
  height: 56px;
  object-fit: contain;
}
.hounItem {
  display: flex;
  justify-content: center;
}
.fragrantBox {
  width: 440px;
  height: 53px;
  z-index: 102;
  margin: 0 auto;
  position: absolute;
  top: 600px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
}
.fraItem {
  display: flex;
  justify-content: center;
  width: 25%;
  height: 78px;
  position: relative;
  .fraIts {
    display: flex;
    justify-content: center;
  }
  .fraItemImg {
    width: 31px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .fraImg {
    width: 92px;
    height: 56px;
    object-fit: cover;
  }
}
.gitf1box {
}
.fruitBox {
  width: 540px;
  height: 53px;
  z-index: 102;
  margin: 0 auto;
  position: absolute;
  top: 660px;
  left: 0;
  right: 0;
  display: flex;
}
.fruits {
  width: 10%;
  height: 78px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.fruitsImg {
  width: 60px;
  height: 78px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fruitsImgItem {
  width: 92px;
  height: 56px;
  object-fit: contain;
}
.smokeBox {
  width: 550px;
  height: 53px;
  z-index: 2;
  margin: 0 auto;
  position: absolute;
  top: 820px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
}
.smokes {
  width: 12.5%;
}
.smoIt {
  position: absolute;
}
.smokeImg {
  width: 54.86px;
  height: 54.86px;
  object-fit: cover;
}
.achImg {
  width: 77px;
  height: 77px;
  object-fit: contain;
}
.acho {
  width: 25%;
}
.achIt {
  position: absolute;
}
.maotai {
  width: 25%;
}
.maotaiIt {
  position: absolute;
}
.maotaiImg {
  width: 60px;
  height: 56px;
}
.pig {
  width: 37.5%;
}
.pigIt {
  position: absolute;
}
.pigImg {
  width: 76px;
  height: 54px;
  object-fit: cover;
}
.wrapper {
  width: 474px;
  height: 410px;
  overflow: hidden;
  margin-top: 30px;
  position: relative;
}
.jidian {
  width: 716px;
  height: 150px;
  position: absolute;
  bottom: 18px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.jidianBox {
  width: 716px;
  height: 150px;
  background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/jd-bg-ly.png")
    no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  position: absolute;
  z-index: 3;
  display: flex;
  padding: 51px 37px 0 37px;
  box-sizing: border-box;
  justify-content: space-between;
  .jdGift {
    width: 100px;
    height: 78px;
    cursor: pointer;
    position: relative;
  }
  .jdgiftImg {
    width: 92px;
    height: 56px;
    object-fit: contain;
  }
}
.jidianTit {
  width: 130px;
  height: 120px;
  background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/jbTitle-bg.png")
    no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  position: absolute;
  top: -30px;
  left: 0;
  right: 0;
  z-index: 3;
  color: #ffce92;
  font-size: 24px;
  line-height: 93px;
  text-align: center;
  cursor: pointer;
}

/* 弹窗背景的样式 */
.popup {
  position: absolute;
  z-index: 2006; /* 保证弹窗在最上层 */
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
}

/* 弹窗内容的样式 */
.popup-content {
  background-color: #fff;
  margin: 5% auto; /* 距顶部15%，居中对齐 */
  // padding: 20px;
  border: 1px solid #888;
  width: 818px; /* 宽度80% */
  max-width: 818px; /* 最大宽度 */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3); /* 添加阴影效果 */
  border-radius: 10px; /* 圆角边框 */
  z-index: 99999999 !important;
}

/* 关闭按钮的样式 */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
.top-nav {
  background: url("../../assets/new/reportBg.png") no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 187px;
  position: relative;
}
.top-title {
  color: #323232;
  display: block;
  font-family: PingFang HK;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  padding-top: 30px;
  padding-bottom: 17px;
}
.close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 13px;
  height: 14px;
}
.reason {
  display: flex;
  padding: 0 40px;
  .symbol {
    color: red;
    padding-top: 4px;
  }
  .reason-span {
    font-family: PingFang SC;
    font-size: 18px;
    font-weight: 500;
    line-height: 25.2px;
    letter-spacing: 0.04em;
    text-align: left;
  }
}
.reason-ct {
  display: flex;
  padding: 20px 0;
  cursor: pointer;
  flex-wrap: wrap;
  .list {
    padding-left: 40px;
    display: flex;
    padding-bottom: 20px;
    span {
      padding-left: 9px;
      font-family: PingFang HK;
      font-size: 18px;
      font-weight: 400;
      text-align: left;
      line-height: 28px;
    }
  }
}
.saveBut {
  width: 322px;
  line-height: 50px;
  margin: 20px auto;
  color: #fff;
  background: #c8c8c8;
  border-radius: 40px;
  text-align: center;
  cursor: pointer;
}
.active-btn {
  background: #45796e;
}

.st-back {
  position: relative;
  cursor: pointer;
}
.st-back:hover {
}
.preview {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  color: #fff;
  border-radius: 10px;
}
.bgImg {
  width: 100%;
  height: 100%;
  background: #000;
  position: fixed;
  // position:absolute;
  right: 0px;
  left: 0;
  z-index: 999;
  margin: 0;
}
.preview-div {
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .close-preview {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: #575757;
    color: #fff;
    line-height: 45px;
    text-align: center;
    position: absolute;
    top: 0px;
    right: -65px;
    cursor: pointer;
  }
  img {
    max-width: 100%; /* 图片最大宽度100%，保证不超出容器 */
    max-height: 100%; /* 图片最大高度100%，保证不超出容器 */
    object-fit: contain; /* 图片适应容器大小 */
    border-radius: 10px;
  }
}
.plus {
  width: 150px;
  height: 150px;
  position: relative;
}
.plus-text {
  display: block;
  font-size: 14px;
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  color: #575757;
}
.reason-div {
  margin: 20px 40px;
}
.reason-textarea {
  cursor: pointer;
  display: flex;
  text-align: left;
  background: #f7f7f7;
  width: 92% !important;
  height: 155px;
  border-radius: 10px;
  border: 0;
  padding: 16px;
  font-size: 18px;
  border: none; /* 去掉边框 */
  outline: none; /* 去掉聚焦时的边框 */
  resize: none; /* 禁止调整大小 */
  color: #000;
}
</style>
